export interface Relance {
    value: number
    unit: 'd' | 'w' | 'm'
}

export const parseRelances = (relanceStr?: string): Relance[] => {
    if (!relanceStr) return []

    return relanceStr.split(';').map(r => {
        const match = r.match(/^(\d+)([dwm])$/)
        if (match) {
            return {
                value: parseInt(match[1]),
                unit: match[2] as 'd' | 'w' | 'm'
            }
        }
        return null
    }).filter(r => r !== null) as Relance[]
}

export const stringifyRelances = (relances: Relance[]): string => {
    return relances.map(r => `${r.value}${r.unit}`).join(';')
}